export const ApiControllers = {
    registration:"Registration/",
    sample:'sample/',
    cardsManageservice:'CardsManageService/',
    CardsActivityService:'CardsActivityService/',
    common : "Common/",
    reportsService:"ReportsService/",
    kycService:"KycService/",
    customers: "Customer/",
    caseManagement:"CaseManagement/",
    energy:"energy/",
}